import React from 'react';
import styled from 'styled-components';
import { Flex, Box } from 'rebass';
import { colors, shadows } from '../../tailwind';
import { Text } from './';

function buildContent(props, loading, noPadding, innerProps) {
  return (
    <ViewBoxInner
      flexDirection={props.flexDirection ? props.flexDirection : 'column'}
      noPadding={noPadding}
      {...innerProps}
    >
      {loading ? (
        <Flex
          justifyContent="center"
          alignItems="center"
          style={{
            height: 100,
            width: '100%',
          }}
        >
          <i className="fal fa-spinner" style={{ fontSize: 22 }} />{' '}
        </Flex>
      ) : (
        props.children
      )}
    </ViewBoxInner>
  );
}

function ViewBox(props) {
  let content;
  const { loading, header, noPadding } = props;

  const {
    m,
    mt,
    mb,
    mr,
    ml,
    mx,
    my,
    p,
    pt,
    pb,
    pr,
    pl,
    px,
    py,
    ...innerProps
  } = props;
  const contentJSX = buildContent(props, loading, noPadding, innerProps);
  if (header) {
    content = (
      <Box {...props}>
        <Text sectionheader mb={3}>
          {header}
        </Text>
        {contentJSX}
      </Box>
    );
  } else {
    content = contentJSX;
  }
  return content;
}

const ViewBoxInner = styled(Flex)`
  box-shadow: ${shadows.default}
  background-color: ${colors.white};
  min-height: 100px;
  padding: ${p => (p.noPadding ? '0px 0px' : '24px 24px')};
  max-width: 90vw;

  @media only screen and (min-width: 700px){
    min-width: ${p => (p.noMin ? null : '668px')};
  }
`;

export default ViewBox;



// WEBPACK FOOTER //
// ./src/components_new/common/ViewBox.js